import printJS from "print-js";
import {
  KUBER_LOGO_BASE64,
  // getKuberLogoForPrint,
} from "constants/kuber-logo-base64";

// Jika AndroidPrintHandler tersedia di window
// const isAndroidPrintHandler = () =>
//   typeof window !== "undefined" && window.AndroidPrintHandler;

// export function printReceipt(data) {
//   const transaction = data;
//   // Format tabel item
// //   const itemsTable = transaction.transaction_items
// //     .map(

// import printJS from "print-js";

// Dummy logo base64 (replace with actual if available)
// const KUBER_LOGO_BASE64 = "";

// Build receipt data (adapted from CartSummary.js)
function buildReceiptJson(transaction, cashPaid = 0, change = 0) {
  const subtotal = Number(transaction.total_price || transaction.transaction_items.reduce(
    (sum, item) => sum + item.quantity * Number(item.price),
    0
  ));
  
  // 1. Calculate product tax by summing the tax_amount of all items
  const productTaxAmount = transaction.transaction_items.reduce(
    (sum, item) => sum + Number(item.tax_amount || 0),
    0
  );

  // 2. Calculate payment tax (tax/fee)
  let paymentTaxAmount = 0;
  if (typeof transaction.tax !== "undefined" && transaction.tax !== null) {
    paymentTaxAmount = Math.max(0, Number(transaction.tax) - productTaxAmount);
  } else {
    const paymentTaxRate = Number(transaction.payment_method?.tax || 0) / 100;
    paymentTaxAmount = (subtotal + productTaxAmount) * paymentTaxRate;
  }

  // 3. Calculate total, paid, and change
  const total = Number(transaction.grand_total || (subtotal + productTaxAmount + paymentTaxAmount));
  const paid = cashPaid || total;
  const changeAmt = change || 0;

  return {
    store: {
      name: "KUBER Adventure & Tours",
      address: "Bali, Indonesia",
      phone: "-",
    },
    transaction: {
      id: transaction.code || "-",
      date: new Date(transaction.created_at || transaction.inserted_at).toLocaleString("id-ID", {
        dateStyle: "medium",
        timeStyle: "short",
      }),
      cashier: transaction.cashier_session?.cashier?.name || transaction.user?.name || "-",
    },
    items: transaction.transaction_items.map((item) => ({
      name: item.item_name || item.name || "-",
      qty: item.quantity,
      price: Number(item.price),
      tax_percent: item.tax_percent,
    })),
    payment: {
      subtotal,
      productTax: productTaxAmount,
      paymentTax: paymentTaxAmount,
      total,
      paid,
      change: changeAmt,
      paymentTaxRate: Number(transaction.payment_method?.tax || 0),
    },
    footer: "Thank you for visiting us!\nwww.kuberbaliadventure.com",
    payment_method: transaction.payment_method?.name || "Cash",
  };
}

// Generate ESC/POS JSON commands for AndroidPrintHandler.printJsonData
function generatePrintCommandsJson(data, charsPerLine = 32) {
  const commands = [];
  const separator = "- ".repeat(Math.floor(charsPerLine / 2));
  // Logo
  if (KUBER_LOGO_BASE64 && KUBER_LOGO_BASE64.length > 100) {
    let base64 = KUBER_LOGO_BASE64;
    if (base64.startsWith("data:image")) {
      const parts = base64.split(",");
      if (parts.length === 2) base64 = parts[1];
    }
    const logoWidth = charsPerLine === 48 ? 256 : 192;
    commands.push({
      type: "image",
      value: base64,
      align: "center",
      width: logoWidth,
      format: "base64",
    });
    commands.push({ type: "line_break" });
  }
  // Store Info
  commands.push({ type: "text", value: data.store.name.toUpperCase(), align: "center", font: "bold", size: "normal" });
  commands.push({ type: "text", value: data.store.address, align: "center" });
  if (data.store.phone && data.store.phone !== "-") {
    commands.push({ type: "text", value: `TEL: ${data.store.phone}`, align: "center" });
  }
  commands.push({ type: "line_break" });
  commands.push({ type: "text", value: separator, align: "center" });
  commands.push({ type: "line_break" });
  // Transaction Info
  commands.push({ type: "text", value: `INVOICE: ${data.transaction.id}`, align: "left" });
  commands.push({ type: "text", value: `CASHIER: ${data.transaction.cashier} ${data.transaction.date}`, align: "left" });
  commands.push({ type: "line_break" });
  commands.push({ type: "text", value: separator, align: "center" });
  commands.push({ type: "line_break" });
  // Items
  data.items.forEach((item) => {
    const itemText = `(${item.qty}x) ${item.name}`;
    const itemPriceFormatted = `Rp ${(item.qty * item.price).toLocaleString("id-ID")}`;
    if (itemText.length + itemPriceFormatted.length > charsPerLine) {
      commands.push({ type: "text", value: itemText, align: "left" });
      commands.push({ type: "text", value: itemPriceFormatted, align: "right" });
    } else {
      const padding = charsPerLine - itemText.length - itemPriceFormatted.length;
      const finalLine = `${itemText}${" ".repeat(Math.max(0, padding))}${itemPriceFormatted}`;
      commands.push({ type: "text", value: finalLine, align: "left" });
    }
  });
  commands.push({ type: "line_break" });
  commands.push({ type: "text", value: separator, align: "center" });
  commands.push({ type: "line_break" });
  // Payment Info
  commands.push({
    type: "text",
    value: `SUBTOTAL: Rp ${data.payment.subtotal.toLocaleString("id-ID")}`,
    align: "right",
  });
  commands.push({
    type: "text",
    value: `ppn/tax : Rp ${data.payment.productTax.toLocaleString("id-ID")}`,
    align: "right",
  });
  if (data.payment.paymentTax > 0) {
    commands.push({
      type: "text",
      value: `${data.payment_method.toLowerCase()} ${data.payment.paymentTaxRate}% : Rp ${data.payment.paymentTax.toLocaleString("id-ID")}`,
      align: "right",
    });
  }
  commands.push({
    type: "text",
    value: `TOTAL: Rp ${data.payment.total.toLocaleString("id-ID")}`,
    align: "right",
    font: "bold",
    size: "normal",
  });
  commands.push({ type: "line_break" });
  commands.push({ type: "text", value: separator, align: "center" });
  commands.push({ type: "line_break" });
  // Payment Details
  commands.push({ type: "text", value: `PAYMENT METHOD: ${data.payment_method}`, align: "right" });
  // Paid & Change (optional)
  if (data.payment.paid) {
    commands.push({ type: "text", value: `PAID: Rp ${data.payment.paid.toLocaleString("id-ID")}`, align: "right" });
  }
  if (data.payment.change) {
    commands.push({ type: "text", value: `CHANGE: Rp ${data.payment.change.toLocaleString("id-ID")}`, align: "right" });
  }
  commands.push({ type: "line_break" });
  commands.push({ type: "text", value: separator, align: "center" });
  commands.push({ type: "line_break" });
  // Footer
  data.footer.split("\n").forEach((line) => {
    commands.push({ type: "text", value: line, align: "center" });
  });
  commands.push({ type: "line_break" });
  commands.push({ type: "line_break" });
  commands.push({ type: "cut" });
  return { commands };
}

// Main printReceipt function
export function printReceipt(transaction, cashPaid = 0, change = 0) {
  const receiptData = buildReceiptJson(transaction, cashPaid, change);
  let charsPerLine = 32;
  try {
    if (
      typeof window.AndroidPrintHandler !== "undefined" &&
      typeof window.AndroidPrintHandler.getPaperSize === "function"
    ) {
      const paperSize = window.AndroidPrintHandler.getPaperSize();
      if (paperSize === "80mm") charsPerLine = 48;
      else if (paperSize === "58mm") charsPerLine = 32;
    }
  } catch (e) {}
  const printCommands = generatePrintCommandsJson(receiptData, charsPerLine);

  if (
    typeof window.AndroidPrintHandler !== "undefined" &&
    typeof window.AndroidPrintHandler.printJsonData === "function"
  ) {
    window.AndroidPrintHandler.printJsonData(JSON.stringify(printCommands));
    return;
  }

  // Fallback ke printJS
  const itemsHtml = receiptData.items
    .map(
      (item) =>
        `<div style="display:flex;justify-content:space-between;margin-bottom:3px;">
        <span style="font-weight:bold;">${item.name} (${item.qty}x)</span>
        <span>Rp ${(item.qty * item.price).toLocaleString("id-ID")}</span>
      </div>`
    )
    .join("");
  const receiptHtml = `
    <div style="text-align:center;font-size:16px;font-weight:bold;font-family:monospace;">
      <div style="margin-bottom:1px;">
        <img src="/Kuber.jpeg" style="width:120px;height:auto;margin-bottom:10px;" alt="Kuber Logo" />
      </div>
      <div style="margin-bottom:5px;">
        <strong style="font-size:18px;">${receiptData.store.name}</strong><br>
        <span style="font-size:12px;">${receiptData.store.address}</span>
      </div>
      <h3>SALES RECEIPT</h3>
      <strong>Kuber POS System</strong><br>
      Invoice: ${receiptData.transaction.id} <br/>
      Date: ${receiptData.transaction.date}<br/>
      <p>Cashier: ${receiptData.transaction.cashier}</p>
    </div>
    <hr>
    ${itemsHtml}
    <hr>
    <div style="display:flex;justify-content:space-between;margin-bottom:3px;">
      <span>Subtotal:</span>
      <span>Rp ${receiptData.payment.subtotal.toLocaleString("id-ID")}</span>
    </div>
    <div style="display:flex;justify-content:space-between;margin-bottom:3px;">
      <span>ppn/tax :</span>
      <span>Rp ${receiptData.payment.productTax.toLocaleString("id-ID")}</span>
    </div>
    ${
      receiptData.payment.paymentTax > 0
        ? `<div style="display:flex;justify-content:space-between;margin-bottom:3px;">
      <span>${receiptData.payment_method.toLowerCase()} ${receiptData.payment.paymentTaxRate}% :</span>
      <span>Rp ${receiptData.payment.paymentTax.toLocaleString("id-ID")}</span>
    </div>`
        : ""
    }
    <div style="display:flex;justify-content:space-between;margin-bottom:3px;font-weight:bold;">
      <strong>Total:</strong>
      <strong>Rp ${receiptData.payment.total.toLocaleString("id-ID")}</strong>
    </div>
    <div style="display:flex;justify-content:space-between;margin-bottom:3px;">
      <span>Bayar:</span>
      <span>Rp ${receiptData.payment.paid.toLocaleString("id-ID")}</span>
    </div>
    <div style="display:flex;justify-content:space-between;margin-bottom:3px;">
      <span>Kembali:</span>
      <span>Rp ${receiptData.payment.change.toLocaleString("id-ID")}</span>
    </div>
    <hr>
    <div style="text-align:center;">
      <p>${receiptData.footer.replace(/\n/g, "<br>")}</p>
    </div>
  `;
  printJS({
    printable: receiptHtml,
    type: "raw-html",
    style: `
      @page { size: 80mm auto; margin: 3mm; }
      body { font-family: 'Courier New', monospace; font-size: 11px; line-height: 1.3; width: 74mm; margin: 0; padding: 0; }
      .receipt-preview .center { text-align: center; }
      .receipt-preview .right { text-align: right; }
      .receipt-preview hr { border: none; border-top: 1px dashed #333; margin: 10px 0; }
      .flex-row { display: flex; justify-content: space-between; margin-bottom: 2px; }
      .flex-row span:first-child { text-align: left; }
      .flex-row span:last-child { text-align: right; }
    `,
  });
}
